import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DashboardImages from './ParallaxImages/DashboardImages';
import ArticleImages from './ParallaxImages/ArticleImages';
import ComingOrNotImages from './ParallaxImages/ComingOrNotImages';
import TeslaImages from './ParallaxImages/TeslaImages';
import RedStationImages from './ParallaxImages/RedStationImages';
import ThinkupImages from './ParallaxImages/ThinkupImages';
import projects from '../../../Assets/consts';
import device from '../../../Assets/Responsive/breakpoints';

const ImageContainer = styled.div`
  /* border: 0.1px dashed black; */
  margin-left: 50%;
  width: 50%;
  height: ${projects.imageContentHeight}vh;
  display: flex;
  flex-flow: column nowrap;
  @media ${device.mobileMaxWidth} {
    width: 100%;
    margin-bottom: 30vh;
    margin-left: 0%;
  }
`;

const ImageBox = styled.div`
  /* outline: 0.1px dashed green; */
  margin-top: 40vh;
  height: 100vh;
  position: relative;
  @media ${device.mobileMaxWidth} {
    margin-top: 30vh;
  }
`;

class ImageContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenHeight: 0,
      scrollHeight: 0,
      scrollPercent: 0,
      projectComponents: [
        ThinkupImages,
        RedStationImages,
        DashboardImages,
        ArticleImages
        // ComingOrNotImages,
        // TeslaImages
      ]
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setState({
      scrollHeight: Math.round(window.document.documentElement.scrollHeight)
    });
    this.setState({
      screenHeight: Math.round(window.document.documentElement.clientHeight)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { body, documentElement } = window.document;
    const sd = Math.max(body.scrollTop, documentElement.scrollTop);
    const sp = (sd / (documentElement.scrollHeight - documentElement.clientHeight)) * 100;
    const minlimit = (documentElement.clientHeight * 100) / documentElement.scrollHeight;
    const maxlimit = (documentElement.clientHeight * 1040) / documentElement.scrollHeight;
    if (sp >= minlimit && sp <= maxlimit) {
      this.setState({ scrollPercent: sp });
    }
  }

  render() {
    const { scrollPercent, scrollHeight, screenHeight, projectComponents } = this.state;
    const { pageSplitTimes } = this.props;
    const boxHeight = pageSplitTimes * 100;

    return (
      <ImageContainer>
        {projectComponents.map((Item, idx) => (
          <ImageBox height={boxHeight}>
            <Item
              boxHeight={boxHeight}
              index={idx + 1}
              scrollPercent={scrollPercent}
              screenHeight={screenHeight}
              scrollHeight={scrollHeight}
            />
          </ImageBox>
        ))}
      </ImageContainer>
    );
  }
}

ImageContent.propTypes = {
  pageSplitTimes: PropTypes.number.isRequired
};

export default ImageContent;
